export const validationFormAddTweetAction = state => {
  return {
    type: "VALIDATION_FORM_ADD_TWEET",
    payload: state
  };
};
